import { render, staticRenderFns } from "./AuthConfig.vue?vue&type=template&id=485f2298&scoped=true&"
import script from "./AuthConfig.vue?vue&type=script&lang=js&"
export * from "./AuthConfig.vue?vue&type=script&lang=js&"
import style0 from "./AuthConfig.vue?vue&type=style&index=0&id=485f2298&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f2298",
  null
  
)

export default component.exports